import { showApiErrorToast } from '@design-system';
import { eventEmitter, handleApiError } from '@utils';
import { createContext, ReactNode, useContext, useEffect, useState } from 'react';

type ErrorContextType = {
    triggerError: (message: string) => void;
};

const ErrorContext = createContext<ErrorContextType | undefined>(undefined);

export const ErrorProvider = ({ children }: { children: ReactNode }) => {
    const [errorMessageTranslationKey, setErrorMessageTranslationKey] = useState<string | null>(null);

    const triggerError = (message: string) => {
        if (message === errorMessageTranslationKey) {
            return;
        }

        setErrorMessageTranslationKey(message);
        setTimeout(() => setErrorMessageTranslationKey(null), 5000);
    };

    useEffect(() => {
        eventEmitter.on('error', triggerError);
        return () => {
            eventEmitter.off('error', triggerError);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (errorMessageTranslationKey) {
            showApiErrorToast({ message: handleApiError(errorMessageTranslationKey) });
        }
    }, [errorMessageTranslationKey]);

    return <ErrorContext.Provider value={{ triggerError }}>{children}</ErrorContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export const useError = () => {
    const context = useContext(ErrorContext);
    if (!context) {
        throw new Error('useError must be used within an ErrorProvider');
    }
    return context;
};
